export default __webpack_public_path__ + "static/media/p7.441ce24e.jpg";